import { Component, OnInit } from '@angular/core';
import {APP_CONFIG} from '../../config';
import {Location} from '@angular/common';
import {UserStorageService} from '../../services/user-storage-service/user-storage.service';
import {TurnsService} from '../../services/turns-services/turns-service/turns.service';
import {ControlDesk} from '../../models/turns-models/control-desk.model';
import {LocationDesk} from '../../models/turns-models/location-desk.model';
import {PendingTurn} from "../../models/turns-models/pending-turn.model";

@Component({
  selector: 'app-pending-turns-screen',
  templateUrl: './pending-turns-screen.component.html',
  styleUrls: ['./pending-turns-screen.component.scss']
})
export class PendingTurnsScreenComponent implements OnInit {

  version: string = APP_CONFIG.appVersion;
  selectedDesk: ControlDesk;
  selectedLocation: LocationDesk;
  pendingTurns: Array<PendingTurn>;

  constructor(
    private userStorageService: UserStorageService,
    private turnsService: TurnsService,
    private location: Location
  ) {
    this.selectedDesk = this.userStorageService.getSelectedDesk();
    this.selectedLocation = this.userStorageService.getSelectedLocationDesk();
  }

  ngOnInit() {
    this.getPendingTurns();
  }

  getPendingTurns() {
    this.turnsService.getTurnsWaiting(
      this.selectedDesk ? this.selectedDesk.internalId : null,
      this.selectedLocation ? this.selectedLocation.internalId : null
    ).subscribe(
      (res) => {
        this.pendingTurns = res;
      },
      (error) => {
        console.dir(error);
      }
    );
  }

  callSelectedTurn(turn) {
    if (this.selectedLocation) {
      this.turnsService.callNextDeskLocationTurn(this.selectedLocation.internalId, turn.turnListinternalId).subscribe();
    }
    this.back();
  }

  back() {
    this.location.back();
  }

}
